module.exports = __webpack_public_path__ + "media/2-5.ba6ad1ad.wav";